var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuadratic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2582_51495)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6953 3.05078C12.0078 1.98438 12.9844 1.25 14.0938 1.25H21.9062C22.5977 1.25 23.1562 1.80859 23.1562 2.5C23.1562 3.19141 22.5977 3.75 21.9062 3.75H14.0938L9.98047 17.8516C9.83984 18.332 9.42969 18.6797 8.93359 18.7422C8.4375 18.8047 7.95312 18.5625 7.70312 18.1328L3.6875 11.25H1.90625C1.21484 11.25 0.65625 10.6914 0.65625 10C0.65625 9.30859 1.21484 8.75 1.90625 8.75H3.6875C4.57812 8.75 5.39844 9.22266 5.84766 9.99219L8.39453 14.3594L11.6953 3.05078ZM16.0234 9.11719C16.5117 8.62891 17.3047 8.62891 17.793 9.11719L19.4062 10.7305L21.0234 9.11328C21.5117 8.625 22.3047 8.625 22.793 9.11328C23.2812 9.60156 23.2812 10.3945 22.793 10.8828L21.1758 12.5L22.793 14.1172C23.2812 14.6055 23.2812 15.3984 22.793 15.8867C22.3047 16.375 21.5117 16.375 21.0234 15.8867L19.4062 14.2695L17.7891 15.8867C17.3008 16.375 16.5078 16.375 16.0195 15.8867C15.5312 15.3984 15.5312 14.6055 16.0195 14.1172L17.6367 12.5L16.0195 10.8828C15.5312 10.3945 15.5312 9.60156 16.0195 9.11328L16.0234 9.11719Z",
    fill: "#3B82F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2582_51495"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 0H23.1562V20H0.65625V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuadratic);
export default __webpack_public_path__ + "static/media/quadratic.ed89c52eee347a1df413f1d47df88a6c.svg";
export { ForwardRef as ReactComponent };